import { paths } from '@/app/routes/paths';
import type { OnboardingStepKey } from '@/store';

/**
 * Maps an onboarding step key to its route path. Steps that don't yet have a
 * UI fall back to the first unimplemented step so the gate never strands the
 * user on a blank route.
 */
export function onboardingPathForStep(step: OnboardingStepKey | null): string {
  switch (step) {
    case 'identity':
      return paths.onboardingIdentity;
    case 'service_sites':
      return paths.onboardingServiceSites;
    case 'your_team':
      return paths.onboardingYourTeam;
    case 'first_intake':
      return paths.onboardingFirstIntake;
    case 'complete':
      return paths.onboardingComplete;
    case null:
    default:
      return paths.dashboard;
  }
}
